<template>
    <div class="home">
        <div class="weui-toptips weui-toptips_warn js_tooltips">错误提示</div>
        <div class="container" id="container">
            <img :src="prodUrl" class="topImg">
            <div class="topTitle">{{ cpdy }}</div>
            <div class="mainDiv">
                <van-sidebar v-model="activeKey" @change="onChange">
                    <van-sidebar-item title="基本信息" />
                    <van-sidebar-item title="企业信息" />
                    <van-sidebar-item title="检验报告" />
                    <van-sidebar-item title="逐只检验" />
                    <van-sidebar-item title="关键工序" />
                </van-sidebar>
                <template v-if="activeKey === 0">
                    <ul class="oneUl">
                        <li v-for="(item, index) in oneData" :key="index" class="oneLi">
                            <div class="oneLab">
                                {{ item.label }}
                            </div>
                            <div class="oneVal">
                                {{ item.value }}
                            </div>
                        </li>
                    </ul>
                </template>
                <template v-if="activeKey === 1">
                    <ul class="oneUl">
                        <li v-for="(item, index) in twoData" :key="index" class="oneLi">
                            <div class="oneLab">
                                {{ item.label }}
                            </div>
                            <template>

                            </template>
                            <div class="oneVal" v-if="item.label !== '营业执照' && item.label !== '生产许可证'">
                                {{ item.value }}
                            </div>
                            <img :src="item.value" class="liImg" v-else>
                        </li>
                    </ul>
                </template>
                <template v-if="activeKey === 2">
                    <div class="oneUl">
                        <div style="height:calc(100vh - 300px)">
                            <pdfview :pdfUrl="pdfUrl" />
                        </div>
                    </div>

                </template>
                <template v-if="activeKey === 3">
                    <div class="oneUl">
                        <div class="oneLab">
                            朔源编码：
                        </div>
                        <div class="oneVal">
                            {{ tracCode }}
                        </div>
                        <!-- <apo-table-list></apo-table-list> -->
                        <el-table :data="tableData" stripe style="width: 100%">
                            <el-table-column prop="date" label="检验项目" min-width="50%">
                            </el-table-column>
                            <el-table-column prop="name" label="结果" min-width="22%">
                            </el-table-column>
                            <el-table-column prop="address" label="操作者" min-width="28%">
                            </el-table-column>
                        </el-table>
                    </div>

                </template>
                <template v-if="activeKey === 4">
                    <div class="oneUl">
                        <div class="oneLab">
                            朔源编码：
                        </div>
                        <div class="oneVal">
                            {{ tracCode }}
                        </div>
                        <!-- <apo-table-list></apo-table-list> -->
                        <el-table :data="tableData2" stripe style="width: 100%;">
                            <el-table-column prop="date" label="名称" min-width="50%">
                            </el-table-column>
                            <el-table-column prop="name" label="结果" min-width="22%">
                            </el-table-column>
                            <el-table-column prop="address" label="操作者" min-width="28%">
                            </el-table-column>
                        </el-table>
                    </div>

                </template>
            </div>
            <!--  底部  -->
            <!-- <div class="el-login-footer">
                <span>Copyright © 2025 临沂诚锦五金工具有限公司 All Rights Reserved.</span>
                <a href="https://beian.miit.gov.cn/">鲁ICP备2025167443号</a>
            </div> -->
        </div>
    </div>
</template>

<script>
import { Sidebar, SidebarItem } from 'vant';
import TableList from '@/components/table.vue';
import PdfNoPage from '@/components/pdfNoPage'
import PdfPage from '@/components/pdfPage'
import pdfview from './pdfview.vue'
import axios from 'axios'
const service = axios.create({
    baseURL: 'https://cj.api.lisuang.com',
    // baseURL: 'http://localhost:9007',
    timeout: 20000
})
export default {
    components: {
        [Sidebar.name]: Sidebar,
        [SidebarItem.name]: SidebarItem,
        'apo-pdf-no-page': PdfNoPage,
        'apo-pdf-page': PdfPage,
        // 'apo-pdf-view': Pdfview,
        'apo-table-list': TableList, pdfview
    },
    mounted() {
        this.onLoad()
    },
    data() {
        return {
            tracCode: 'LYCJ' + this.$route.params.id,
            active: 0,
            activeKey: 0,
            items: [{ text: '分组 1' }, { text: '分组 2' }],
            pdfUrl: '',
            prodUrl: '',
            oneData: [],
            twoData: [
        ],
            tableData: [],
            tableData2: [],
            cpdy:''
        };
    },
    methods: {
        onLoad() {
            service({
                url: '/qhapi/info/getByTracCode',
                method: 'get',
                params: { tracCode: this.tracCode,path:this.$route.path }
            }).then(res => {
                const data = res.data.data
                this.pdfUrl = data.jybg
                this.prodUrl = data.cptp
                this.oneData = []
                this.cpdy = data.prodDy
                this.oneData.push({ label: '产品单元', value: data.prodDy })
                this.oneData.push({ label: '产品编号', value: data.prodCode })
                this.oneData.push({ label: '批次编号', value: data.bchno })
                this.oneData.push({ label: '规格型号', value: data.spec })
                this.oneData.push({ label: '额定出口压力', value: data.edckyl })
                this.oneData.push({ label: '额定出口流量', value: data.edckll })
                this.oneData.push({ label: '执行标准号', value: data.exestdNo })
                this.oneData.push({ label: '生产日期', value: data.manuDateStr })
                this.twoData = []
                this.twoData.push({ label: '企业名称', value: data.qiyeName })
                this.twoData.push({ label: '统一信用代码', value: data.qiyeUscc })
                this.twoData.push({ label: '生产地址', value: data.qiyeAddr })
                this.twoData.push({ label: '联系电话', value: data.qiyeTel })
                this.twoData.push({ label: '生产许可证编号', value: data.scxkzNo })
                this.twoData.push({ label: '营业执照', value: data.yyzz })
                if (data.scxkz) {
                    this.twoData.push({ label: '生产许可证', value: data.scxkz })
                }
                this.tableData = []
                this.tableData.push({ date: '外观检验', name: '合格', address: data.optorWgjy })
                this.tableData.push({ date: '气密性检验(低压)', name: '合格', address: data.optorQixjydi })
                this.tableData.push({ date: '气密性检验(高压)', name: '合格', address: data.optorQixjygao })
                this.tableData.push({ date: '流量安全装置检验', name: '合格', address: data.optorLlaqzz })
                this.tableData.push({ date: '最大出口压力', name: data.maxCkyl, address: data.optorMaxckyl })
                this.tableData.push({ date: '最小出口压力', name: data.minCkyl, address: data.optorMinckyl })
                this.tableData.push({ date: '关闭压力', name: data.closeCkyl, address: data.optorGbyl })
                this.tableData2 = []
                this.tableData2.push({ date: '材料检验', name: '合格', address: data.optorCljy })
                this.tableData2.push({ date: '壳体压铸', name: '合格', address: data.optorKtyz })
                this.tableData2.push({ date: '壳体外观，最小壁厚及尺寸检验', name: '合格', address: data.optorKtwg })
                this.tableData2.push({ date: '产品装配', name: '合格', address: data.optorCpzp })
                this.tableData2.push({ date: '装配工序检验', name: '合格', address: data.optorZpgx })
                this.tableData2.push({ date: '抽样检验', name: '合格', address: data.optorCyjy })
                this.tableData2.push({ date: '压力安全装置检验【若有】', name: '合格', address: data.optorYlaqzz })
            })
        },

        onChange(index) {
            this.activeKey = index
        },
    }
};
</script>

<style scoped lang="less">
@sidebar-width: 100px
.page__hd {
    padding: 40px
}

.page__bd_spacing {
    padding: 0 15px
}

.topImg {
    width: 100%;
}

.mainDiv {
    position: relative;
    margin-top: 20px;
}

.topTitle {
    padding: 8px;
    text-align: center;
    font-weight: 700;
    font-size: 20px;
    color: #fff;
    background-color: #142d96;
    letter-spacing: 1.2px;
}

.oneUl {
    position: absolute;
    top: 0px;
    width: calc(100% - 134px);
    display: flex;
    left: 105px;
    flex-direction: column;
    justify-content: left;
    overflow-y: auto;
    margin-left: 1%;
    padding: 6px 8px;
    border-radius: 5px;
    background-color: #fff;
    -webkit-box-shadow: 0 0 7px 0 rgba(0, 0, 0, .1);
    box-shadow: 0 0 7px 0 rgba(0, 0, 0, .1);
}

.oneLi {
    display: flex;
    flex-direction: column;
    justify-content: left;
    border-bottom: 1px dashed #cecece
}

.oneLab {
    font-size: 18px;
    color: #606266;
    text-align: left;
    line-height: 30px;
    height: 30px;
}

.oneVal {
    line-height: 39px;
    min-height: 39px;
    text-align: left;
}

.liImg {
    width: 250px;
    height: 187px;
}

/deep/ .van-sidebar-item--select::before {
    background-color: #142d96;
    height: 100%;
    width: 2px;
}

/deep/ .van-sidebar {
    width: 100px;
}
.el-login-footer {
    height: 40px;
    line-height: 40px;
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center;
    color: #fff;
    font-family: Arial;
    font-size: 12px;
    letter-spacing: 1px;
}
</style>
